import { API_BASE_URL } from "./apiBaseUrl";

export interface City {
  id: string;
  name: string;
  outletId?: string | null;
  address?: string;
  cashName?: string;
  /** TRADEOUTLET.ONLY_PICKUP: только самовывоз */
  onlyPickup?: boolean;
}

class CityApi {
  private baseUrl: string;

  constructor() {
    this.baseUrl = API_BASE_URL;
  }

  async getCities(): Promise<City[]> {
    try {
      const response = await fetch(`${this.baseUrl}/GetCity.php`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!Array.isArray(data)) {
        throw new Error("Invalid response format");
      }

      return data;
    } catch (error) {
      console.error("Error fetching cities:", error);
      throw error;
    }
  }
}

export const cityApi = new CityApi();
